export default "__VITE_ASSET__Bg6fI9SW__"